var path = 'admin/templates/menu.html';
var html = "<div class=\"section-header text-center\">\n  <h1 class=\"main-title\">{{title}}</h1>\n</div>\n\n<div template-include include-name=\"admin.menu\"></div>\n\n<div class=\"box\">\n  <div hmr-notifications></div>\n</div>\n\n<div class=\"box wrapper bg-white col-xs-12 col-sm-8 col-md-12\">\n  <ui-view></ui-view>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/admin/templates/menu.html
 ** module id = 284
 ** module chunks = 0
 **/